import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./auth/ProtectedRoute";
import PublicLayout from "./layout/PublicLayout";
import AppLayout, { ADMIN_SECTIONS } from "./layout/AppLayout";
import Landing from "./pages/Landing";
import HowItWorks from "./pages/HowItWorks";
import FAQ from "./pages/FAQ";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Receipts from "./pages/Receipts";
import ReceiptDetail from "./pages/ReceiptDetail";
import Review from "./pages/Review";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Reports from "./pages/Reports";
import Upload from "./pages/Upload";
import Cards from "./pages/Cards";
import CardDetail from "./pages/CardDetail";
import Vendors from "./pages/Vendors";
import VendorDetail from "./pages/VendorDetail";
import Clients from "./pages/Clients";
import Connections from "./pages/Connections";
import InboxActivity from "./pages/InboxActivity";
import Settings from "./pages/Settings";
import QuickBooks from "./pages/QuickBooks";
import AdminOverview from "./pages/admin/Overview";
import AdminUsers from "./pages/admin/Users";
import AdminMailboxes from "./pages/admin/Mailboxes";
import AdminMessages from "./pages/admin/Messages";
import AdminReports from "./pages/admin/Reports";
import AdminAiCalls from "./pages/admin/AiCalls";
import AdminBlocklist from "./pages/admin/Blocklist";
import AdminSystemSettings from "./pages/admin/SystemSettings";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Route>

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="receipts" element={<Receipts />} />
          <Route path="receipts/:id" element={<ReceiptDetail />} />
          <Route path="review" element={<Review />} />
          <Route path="reports" element={<Reports />} />
          <Route path="upload" element={<Upload />} />
          <Route path="cards" element={<Cards />} />
          <Route path="cards/:last4" element={<CardDetail />} />
          <Route path="vendors" element={<Vendors />} />
          <Route path="vendors/:vendor" element={<VendorDetail kind="vendor" />} />
          <Route path="clients" element={<Clients />} />
          <Route path="clients/:vendor" element={<VendorDetail kind="client" />} />
          <Route path="connections" element={<Connections />} />
          <Route path="inbox-activity" element={<InboxActivity />} />
          <Route path="quickbooks" element={<QuickBooks />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        <Route
          path="/admin"
          element={
            <ProtectedRoute admin>
              <AppLayout sections={ADMIN_SECTIONS} mode="admin" />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<AdminOverview />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="mailboxes" element={<AdminMailboxes />} />
          <Route path="messages" element={<AdminMessages />} />
          <Route path="reports" element={<AdminReports />} />
          <Route path="ai-calls" element={<AdminAiCalls />} />
          <Route path="blocklist" element={<AdminBlocklist />} />
          <Route path="settings" element={<AdminSystemSettings />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
